import {useState} from "react";
import {kMethodQuestion} from "../../../constants/objects";
import SystemDraftQuestionCard from "../../cards/SystemDraftQuestionCard";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";
import {kAboutMethodTexts} from "../../../constants/texts";
import AboutMethodImage from "../../images/aboutScreen/AboutMethodImage";
import {kProgramsLink} from "../../../constants/links";
import AboutMethodProgramImage from "../../images/aboutScreen/AboutMethodProgramImage";
import SystemOptionsCard from "../../cards/SystemOptionsCard";
import AboutMethodLevelComplexityImage from "../../images/aboutScreen/AboutMethodLevelComplexityImage";

export default function AboutMethodSection() {
    // Used in AboutContent to display content
    // of method section in desktop / tablet modes

    // PROPERTIES
    const [selectedOption, setSelectedOption] = useState(null)

    // BUILD
    return(
        <div className={"w-full flex flex-col justify-start items-center pb-[24px] pt-[32px] font-normal text-[18px] text-greyLight9"}>
            {/** STATEMENT */}
            <AboutMethodImage />
            <div className={"mt-[16px]"}>
                <span>
                    {kAboutMethodTexts.introOne}
                </span>
                <a className={"text-primaryLight2 hover:underline"}
                   href={kProgramsLink}
                   target="_blank"
                   rel="noopener noreferrer">
                    {kAboutMethodTexts.introLink}
                </a>
                <span>
                    {aboutScreenHighlightWords(kAboutMethodTexts.introTwo, ['découpé en savoir-faire', 'deux types'])}
                </span>
            </div>
            <section className={"mt-[4px]"}>
                <ul className="list-disc list-outside pl-[16px]">
                    <li>
                        {aboutScreenHighlightWords(kAboutMethodTexts.one, ['fondamentaux / simples', 'connaissance', 'applications directes du cours'])}
                    </li>
                    <li className={"mt-[4px]"}>
                        {aboutScreenHighlightWords(kAboutMethodTexts.two, ['complexes'])}
                    </li>
                </ul>
            </section>
            <AboutMethodProgramImage />


            <div className={"mt-[24px]"}>
                <span>
                    {aboutScreenHighlightWords(kAboutMethodTexts.three, ['chaîne de progression', 'abstraite'])}
                </span>
            </div>
            <AboutMethodLevelComplexityImage />

            <div className={"mt-[24px]"}>
                <span>
                    {aboutScreenHighlightWords(kAboutMethodTexts.four, ['apprennent par cœur', 'sans les comprendre', 'savoir-faire complexe soit abordé sans que la base soit acquise', 'maîtrise absolue des fondamentaux', 'difficultés lors des évaluations', 'brevet', 'décourager l\'élève'])}
                </span>
            </div>

            <div className={"mt-[12px]"}>
                <span className={""}>
                    {aboutScreenHighlightWords(kAboutMethodTexts.oneT, ['Cours et exercices', 'connaissance associée', 'flash', 'QCM rapide', 'tester la compréhension', 'l\'application'])}
                </span>
            </div>
            <div className={"mt-[16px] w-full"}>
                <SystemDraftQuestionCard question={kMethodQuestion}
                                         selectedOption={selectedOption}
                                         setSelectedOption={setSelectedOption} />
            </div>


            <div className={"mt-[16px]"}>
                <span>
                    {aboutScreenHighlightWords(kAboutMethodTexts.twoT, ['erreurs fréquentes observées en classe', 'mauvaise compréhension du concept', 'savoir-faire antérieur'])}
                </span>
            </div>

            <div className={"mt-[12px]"}>
                <span>
                    {aboutScreenHighlightWords(kAboutMethodTexts.threeT, ['chaque proposition', 'est expliquée', 'comprendre ses erreurs', 'progresser'])}
                </span>
            </div>
            <div className={"mt-[16px] w-full"}>
                <SystemOptionsCard question={kMethodQuestion} />
            </div>
        </div>
    );
}